import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { post } from '../lib/ajax'

export default component((node) => {
  const productId = $(node).attr('data-product-id')
  const data = {
    methods: [
      {
        method: 'bottomline',
        params: {
          pid: productId,
        },
        format: 'html',
      },
    ],
    app_key: 'nTfom57rHljn6x8qn35bk7J9KqzjGq5iiMVg1Rbk',
    is_mobile: false,
  }

  post('https://staticw2.yotpo.com/batch', data).then((res) => {
    const html = res[0].result
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const el = doc.querySelector('.star-clickable a.text-m')
    const text = parseInt(el.textContent)
    el.textContent = text
    $(node).html(doc.querySelector('body').innerHTML)
  })

  const handleScroll = () => {
    const reviewsSection = document.getElementById('new-product-reviews')
    const firstRadio = $(reviewsSection).findEl('[role="radiogroup"]').firstElementChild
    const scrollYWithOffset = reviewsSection.getBoundingClientRect().top - 125

    window.scrollTo({
      top: scrollYWithOffset,
      behavior: 'smooth',
    })
    firstRadio ? firstRadio.focus() : null
  }

  $(node).on('click', handleScroll)
  $(node).on('keypress', (e) => {
    if (e.code === 'Enter') handleScroll()
  })

  return () => {
    $(node).off('click', handleScroll)
    $(node).off('keypress', (e) => {
      if (e.code === 'Enter') handleScroll()
    })
  }
})
